import React, { Component } from 'react';
import { Table, Popup } from 'semantic-ui-react';

class StatTable extends Component {
  componentDidMount() {
    const { colWidth } = this.props;

    const minWidth = colWidth.reduce((total, val, idx) => {
      return total + val;
    });

    var lastWidth;
    const watch = () => {
      window.cancelAnimationFrame(this.watcher);

      // 표는 매 프레임 다시 조회한다. 마운트 시점에 한 번만 잡으면
      // 표가 늦게 그려지거나 교체될 때 낡은 참조(또는 null)에 묶여 루프가 아무 일도 못 한다.
      const table = document.querySelector('.table-container table');
      const tbody = document.querySelector('.table-container table tbody');
      const thead = document.querySelector('.table-container table thead');

      // 리렌더 중간에는 table/tbody/thead가 잠시 없을 수 있으므로 접근 전에 확인한다.
      if (table && tbody && thead) {
        if (lastWidth != table.offsetWidth || tbody.style.minWidth == 'auto') {
          if (lastWidth > table.offsetWidth) {
            tbody.style.minWidth = 'auto';
          } else {
            if (tbody.scrollWidth < minWidth) {
              let rest = minWidth - tbody.scrollWidth;
              tbody.style.minWidth = thead.scrollWidth + rest + 'px';
              thead.style.minWidth = thead.scrollWidth + rest + 'px';
            } else {
              tbody.style.minWidth = thead.scrollWidth + 'px';
              thead.style.minWidth = thead.scrollWidth + 'px';
            }
          }
          lastWidth = table.offsetWidth;
        }
      }
      this.watcher = requestAnimationFrame(watch);
    };
    this.watcher = window.requestAnimationFrame(watch);
  }

  // 언마운트 후에도 루프가 남아 사라진 DOM에 접근하는 것을 막는다.
  componentWillUnmount() {
    window.cancelAnimationFrame(this.watcher);
  }

  doScrollMove = () => {
    $('#test').scroll(function() {
      var elem = $('#test');
      if (elem[0].scrollHeight - elem.scrollTop() == elem.outerHeight()) {
      }
    });
  };

  makeFooter = (arr, colWidth) => {
    return arr.map((item, idx) => {
      const align = item.textAlign ? item.textAlign : 'center';

      return (
        <Table.HeaderCell
          key={idx}
          textAlign={align}
          colSpan={item.colSpan}
          style={{
            backgroundColor: '#243346',
            color: '#fff'
          }}
        >
          {item.content}
        </Table.HeaderCell>
      );
    });
  };

  makeHeader = (arr, colWidth) => {
    return arr.map((item, idx) => {
      const align = item.textAlign ? item.textAlign : 'center';
      return (
        <Table.HeaderCell
          key={idx}
          textAlign={align}
          style={{
            minWidth: colWidth[idx] + 'px',
            width: item.maxWidth ? item.maxWidth : null
          }}
        >
          {item.content}
        </Table.HeaderCell>
      );
    });
  };

  makeRow = (data, colWidth) => {
    const minWidth = colWidth.reduce((total, val, idx) => {
      return total + val;
    });

    if (typeof data === 'string') {
      return (
        <Table.Row>
          <Table.Cell colSpan={colWidth.length} textAlign="center">
            {data}
          </Table.Cell>
        </Table.Row>
      );
    } else {
      const table = this.subTable(data, colWidth);
      return (
        <Table.Row>
          <Table.Cell colSpan={colWidth.length} style={{ padding: 0 }}>
            {table}
          </Table.Cell>
        </Table.Row>
      );
    }
  };

  subTable = (data, colWidth) => {
    if (typeof data === 'string') {
      const body = this.subBody(data, colWidth);

      return (
        <Table className="tb-sub" unstackable>
          {body}
        </Table>
      );
    } else {
      return data.map((item, idx) => {
        const header = this.subHeader(item.header),
          body = this.subBody(item.body, colWidth);

        return (
          <Table key={idx} className="tb-sub depth2-table" unstackable>
            {header}
            {body}
          </Table>
        );
      });
    }
  };

  subHeader = (data) => {
    let start_idx = 0;
    const headerCell = data.map((item, idx) => {
      const align = item.textAlign ? item.textAlign : 'center';

      let prev_idx = 0,
        wid = 0;
      if (item.colSpan) {
        prev_idx = start_idx;
        start_idx += item.colSpan;
      } else {
        prev_idx = start_idx;
        start_idx += 1;
      }

      return (
        <Table.HeaderCell key={idx} colSpan={item.colSpan} textAlign={align}>
          {item.content}
        </Table.HeaderCell>
      );
    });

    return (
      <Table.Header>
        <Table.Row>{headerCell}</Table.Row>
      </Table.Header>
    );
  };

  subBody = (data, colWidth) => {
    const bodyData = data.map((item, key) => {
      return this.subRow(item, colWidth, key);
    });

    return <Table.Body>{bodyData}</Table.Body>;
  };

  subRow = (data, colWidth, key) => {
    const cells = data.row.map((item, idx) => {
      const fontColor = item.fontColor ? item.fontColor : 'black',
        align = item.textAlign ? item.textAlign : 'center';

      let widthVal = 0;
      if (idx === 1 || idx === colWidth.length - 1) {
        //border-left, border-right 값 만큼만 빼기
        widthVal = colWidth[idx] - 1;
      } else {
        widthVal = colWidth[idx];
      }

      return (
        <Table.Cell
          key={idx}
          textAlign={align}
          style={{
            minWidth: widthVal,
            color: fontColor,
            width: item.maxWidth ? item.maxWidth : null,
            maxWidth: item.maxWidth ? item.maxWidth : null
          }}
        >
          {item.isTooltip ? (
            <Popup content={item.content} inverted trigger={<span>{item.content}</span>} />
          ) : (
            item.content
          )}
          {/* {item.content} */}
        </Table.Cell>
      );
    });

    return (
      <Table.Row key={key} style={{ backgroundColor: data.backgroundColor }}>
        {cells}
      </Table.Row>
    );
  };

  render() {
    const { colWidth, header, data, footer } = this.props;

    let headData = <Table.HeaderCell colSpan={colWidth.length} />,
      bodyData = data,
      footerData = <Table.HeaderCell colSpan={colWidth.length} />;

    if (header) {
      headData = this.makeHeader(header, colWidth);
    }

    if (data) {
      bodyData = this.makeRow(data, colWidth);
    }

    if (footer) {
      footerData = this.makeFooter(footer, colWidth);
    }

    return (
      <Table className="tb-stat">
        <Table.Header>
          <Table.Row>{headData}</Table.Row>
        </Table.Header>

        <Table.Body id="test" onScroll={this.doScrollMove}>
          {bodyData}
        </Table.Body>

        <Table.Footer>
          <Table.Row>{footerData}</Table.Row>
        </Table.Footer>
      </Table>
    );
  }
}

export default StatTable;
